'use client';

import { useEffect, useState } from 'react';
import {
  FacebookShareButton,
  OKShareButton,
  TelegramShareButton,
  TwitterShareButton,
  ViberShareButton,
  VKShareButton,
  WhatsappShareButton,
} from 'react-share';
import {
  FacebookIcon,
  OKIcon,
  TelegramIcon,
  TwitterIcon,
  ViberIcon,
  VKIcon,
  WhatsappIcon,
} from 'react-share';

import { Share } from 'lucide-react';
import { CopyButton } from '@/components/ui/copy-btn';
import { BottomDrawer } from '@/components/bottom-drawer/bottom-drawer';

interface Action {
  text: React.ReactNode;
  key: string;
}

export const ShareButton = () => {
  const [visible, setVisible] = useState(false);
  const [url, setUrl] = useState('');
  useEffect(() => {
    setUrl(window.location.href);
  }, []);

  const actions: Action[] = [
    {
      text: (
        <OKShareButton className="flex gap-2 items-center w-full" url={url}>
          <OKIcon round size={30} />
          <span>Одноклассники</span>
        </OKShareButton>
      ),
      key: 'ok',
    },
    {
      text: (
        <TwitterShareButton
          className="flex gap-2 items-center w-full"
          url={url}
        >
          <TwitterIcon round size={30} />
          <span>Twitter</span>
        </TwitterShareButton>
      ),
      key: 'twitter',
    },
    {
      text: (
        <ViberShareButton className="flex gap-2 items-center w-full" url={url}>
          <ViberIcon round size={30} />
          <span>Viber</span>
        </ViberShareButton>
      ),
      key: 'viber',
    },
    {
      text: (
        <VKShareButton className="flex gap-2 items-center w-full" url={url}>
          <VKIcon round size={30} />
          <span>VK</span>
        </VKShareButton>
      ),
      key: 'vk',
    },
    {
      text: (
        <WhatsappShareButton
          className="flex gap-2 items-center w-full"
          url={url}
        >
          <WhatsappIcon round size={30} />
          <span>Whatsapp</span>
        </WhatsappShareButton>
      ),
      key: 'whatsapp',
    },
    {
      text: (
        <FacebookShareButton
          className="flex gap-2 items-center w-full"
          url={url}
        >
          <FacebookIcon round size={30} />
          <span>Facebook</span>
        </FacebookShareButton>
      ),
      key: 'facebook',
    },
    {
      text: (
        <TelegramShareButton
          className="flex gap-2 items-center w-full"
          url={url}
        >
          <TelegramIcon round size={30} />
          <span>Telegram</span>
        </TelegramShareButton>
      ),
      key: 'telegram',
    },
    {
      text: (
        <CopyButton
          className="w-full justify-start h-full flex gap-2 items-center text-lg"
          value={url}
        >
          <div className="mr-2">Копировать</div>
        </CopyButton>
      ),
      key: 'copy',
    },
  ];
  return (
    <>
      <Share
        onClick={() => setVisible(true)}
        className="text-gray-900"
        strokeWidth={1}
        size={26}
      />
      <BottomDrawer
        visible={visible}
        close={() => setVisible(false)}
        showCloseButton
      >
        <div className="text-gray-900 text-lg text-center py-2">
          Выбери социальную сеть для отправки
        </div>
        <div className="flex flex-col">
          {actions.map((action) => (
            <div
              key={action.key}
              className="py-3 border-b border-gray-100 last:border-b-0"
              onClick={() => setVisible(false)}
            >
              {action.text}
            </div>
          ))}
        </div>
        <button
          className="w-full py-3 mt-2 text-center text-gray-500"
          onClick={() => setVisible(false)}
        >
          Отмена
        </button>
      </BottomDrawer>
    </>
  );
};
